var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newsletterId)?_c('div',{attrs:{"id":"newsletter"}},[_c('newsletter-nav',{attrs:{"newsletterId":_vm.newsletterId}}),_vm._v(" "),_c('email',{attrs:{"emailId":_vm.newsletterId,"emailType":"newsletter","sendEmailConfirmation":_vm.sendEmailConfirmation}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95dcbb6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Newsletter.vue
// module id = 1258
// module chunks = 1